<template>
  <div class="main-container">
    <div class="main-content-wrap">
      <div class="main-content-pannel">
        <option-menu class="no-bg no-border">
          <div class="content-title-wrap">
            <div class="main-content-title">Projects</div>
            <div class="main-content-menu">
              <div class="searchbox">
                <label for="roleFilter">
                  <i
                    v-if="!filterTxt"
                    class="material-icons-outlined align-middle"
                    >search</i
                  >
                  <i
                    v-else
                    @click="onQuickFilterChanged"
                    class="material-icons-outlined align-middle"
                    >clear</i
                  >
                </label>
                <input
                  id="roleFilter"
                  type="text"
                  @keyup="onQuickFilterChanged"
                  :value="filterTxt"
                  placeholder="Search"
                />
              </div>
              <button
                class="btn primary"
                href="javascript:void(0);"
                @click="addProject()"
                :class="{ active: editOpen == 1 }"
                title="Add Project"
              >
                <i class="material-icons-outlined align-middle">add</i>
                Add Project
              </button>
            </div>
          </div>
        </option-menu>
        <div class="main-bg p-0 m-t-0 m-b-0">
          <ag-grid-vue
            style="width: 100%; height: calc(100vh - 201px)"
            class="ag-theme-material"
            :gridOptions="gridOptions"
            :columnDefs="columnDefs"
            @column-resized="onColumnResized"
            @first-data-rendered="onFirstDataRendered"
            @grid-size-changed="onFirstDataRendered"
            :rowData="rowData"
          ></ag-grid-vue>
        </div>
      </div>
      <transition name="edit-pannel">
        <edit-pannel v-model="editOpen" @input="closeEditPannel" title>
          <PanelProject
            ref="addProject"
            v-if="editOpen == 1"
            :propsData="propsData"
            :pannelData="pannelData"
            :submitLoading="submitLoading"
            :projectPhaseOptions="projectPhaseOptions"
            :companyOptions="companyOptions"
            @saveProject="saveProject"
          ></PanelProject>
          <PanelProject
            ref="editProject"
            v-if="editOpen == 2"
            :propsData="propsData"
            :pannelData="pannelData"
            :submitLoading="submitLoading"
            :projectPhaseOptions="projectPhaseOptions"
            :companyOptions="companyOptions"
            @saveProject="saveProject"
          ></PanelProject>
        </edit-pannel>
      </transition>
    </div>
  </div>
</template>


<script>
import EditPannel from "@/components/EditPannel.vue";
import OptionMenu from "@/components/OptionMenu.vue";
import { db } from "@/vendor/firebase";
import { updateDocById, addDoc, deleteDoc } from "@/vendor/database";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import "@/assets/css/ag-grid.scss";
import { mapState } from "vuex";
import * as constant from "@/constant/constant";
import { dateformat } from "@/utils/utils";
import { httpGet } from "@/http/http";
import PanelProject from "@/components/admin/projectAdmin/PanelProject.vue";
import ProjectEdit from "@/components/admin/projectAdmin/ProjectAction";
import GridSubmitSourced from "@/components/admin/projectAdmin/GridSubmitSourced";
import GridAttachment from "@/components/admin/projectAdmin/GridAttachment";
import GridDate from "@/components/admin/projectAdmin/GridDate";
import GridCompany from "@/components/admin/projectAdmin/GridCompany";
import GridDropdownMenu from "@/components/admin/projectAdmin/GridDropdownMenu";
import GridPhase from "@/components/admin/projectAdmin/GridPhase";
import * as utils from "@/utils/utils";
import moment from "moment-timezone";

//  import testData from '@/testData.js';     //test data

export default {
  props: ["editOpenTitle"],
  data() {
    return {
      filterTxt: "",
      gridOptions: {},
      columnDefs: null,
      rowData: [],
      editOpen: false,
      editProjectId: null,
      propsData: null,

      pannelData: {},
      isPannelInit: false,

      projects: null,
      submitLoading: false,
      projectPhases: null,
      projectPhaseOptions: [],
      companies: null,
      companyOptions: [],

      dd: {
        index: null,
        el: null,
        isOpen: false,
      },
    };
  },
  watch: {
    editOpenTitle: function (val) {
      this.editOpen = val;
    },
    projects: function () {
      this.updateRowData();
    },
    projectPhases: function () {
      this.projectPhaseOptions = [];
      if (this.projectPhases) {
        this.projectPhaseOptions = this.projectPhases.map((item) => ({
          text: item.name,
          value: item.name,
        }));
      }
    },
    companies: function () {
      if (this.companies && this.companies.length > 0) {
        this.companyOptions = this.companies.map((item) => ({
          text: item.name,
          value: item.id,
        }));
      }
      this.updateRowData();
    },
  },
  computed: {
    ...mapState(["user"]),
  },
  components: {
    EditPannel,
    OptionMenu,
    AgGridVue,
    PanelProject,
    ProjectEdit,
    GridSubmitSourced,
    GridAttachment,
    GridDate,
    GridCompany,
    GridDropdownMenu,
    GridPhase,
  },
  beforeMount() {
    this.createColumnDefs();
    this.createRowData();
    this.createPannelData();
  },
  created: function () {
    this.$EventBus.$on("globalClick", (event) => {
      this.hideAgDropdown(event);
    });
    setTimeout(() => {
      this.enableSetLocal = true;
    }, 3000);
  },
  methods: {
    refreshRowData: function () {
      this.gridOptions.api.setRowData(this.rowData);
    },
    addProject: function () {
      if (!this.isPannelInit) return;
      this.submitLoading = false;
      this.editProjectId = null;
      this.propsData = {
        type: constant.PANEL_TYPES.ADD,
      };
      this.openEditPannel(1, "Add Project", true);
    },
    editProject: function (data) {
      if (this.editOpen == 2 && this.editProjectId == data.index) {
        this.editOpen = false;
        return;
      }
      this.submitLoading = false;
      this.propsData = {
        ...data,
        type: constant.PANEL_TYPES.EDIT,
      };
      this.editProjectId = data.index;
      this.openEditPannel(2, "Edit Project", false);
    },
    // filter
    onQuickFilterChanged(event) {
      this.filterTxt = event.target.value;
      this.gridOptions.api.setQuickFilter(event.target.value);
    },
    createColumnDefs: function () {
      this.gridOptions = {
        defaultColDef: {
          //            enableValue: true,
          enableRowGroup: true,
          enablePivot: true,
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true,
        },
        context: {
          componentParent: this,
        },
        animateRows: true,
        sideBar: false,
        enableCellTextSelection: true,
        pagination: true,
        paginationPageSize: 9,
        paginationNumberFormatter: function (params) {
          return "[" + params.value.toLocaleString() + "]";
        },
      };
      this.columnDefs = [
        {
          headerName: "Company",
          field: "companyName",
          cellRendererFramework: "GridCompany",
        },
        {
          headerName: "Submited/Sourced",
          cellRendererFramework: "GridSubmitSourced",
        },
        { headerName: "Title", field: "title" },
        {
          headerName: "Amount",
          field: "amount",
          cellClass: ["font-color-green", "text-right"],
        },
        {
          headerName: "Date",
          comparator: utils.dateComparator,
          sortingOrder: ["desc", "asc"],
          sort: { direction: "desc", priority: 0 },
          cellRendererFramework: "GridDate",
        },
        {
          headerName: "Phase",
          field: "phase",
          width: 200,
          cellRendererFramework: "GridPhase",
        },
        {
          headerName: "",
          cellRendererFramework: "GridDropdownMenu",
          width: 200,
          cellClass: "overflow-visible",
        },
      ];
    },
    createRowData: async function () {
      this.$bind("projects", db.collection("gigs"));
      this.$bind("projectPhases", db.collection("project_phases"));
      this.$bind("companies", db.collection("companies"));
    },
    updateDeleteRowData: function (uid) {
      if (this.rowData) {
        let index;
        for (const i in this.rowData) {
          if (this.rowData[i].uid == uid) {
            index = i;
            break;
          }
        }
        if (index !== undefined) {
          this.rowData.splice(index, 1);
        }
        this.refreshRowData();
      }
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onColumnResized(params) {
      params.api.resetRowHeights();
    },
    openCurrentAgDropdown: function (item, el) {
      if (this.dd.isOpen) {
        this.$set(this.rowData[this.dd.index], "ddOpen", false);
      }
      this.dd.isOpen = item.ddOpen;
      this.dd.index = item.rowindex;
      this.dd.el = el;
    },
    hideAgDropdown: function (e) {
      if (this.dd.el && !this.dd.el.contains(e.target)) {
        this.hideCurrentAgDropdown();
      }
    },
    hideCurrentAgDropdown: function () {
      this.$set(this.rowData[this.dd.index], "ddOpen", false);
      this.dd.isOpen = false;
    },
    // edit pannel: control open which component
    openEditPannel: function (action, title, isToggle) {
      if (this.editOpen && this.editOpen != action) {
        this.editOpen = action;
        this.emitEditPannel(title);
        return;
      }
      if (isToggle) {
        this.editOpen = this.editOpen ? false : action;
      } else {
        this.editOpen = action;
      }
      this.emitEditPannel(title);
    },
    closeEditPannel: function () {
      this.editOpen = false;
      this.emitEditPannel();
    },
    emitEditPannel: function (title) {
      const param = {
        title: title,
        editOpen: this.editOpen,
      };
      this.$emit("openEditPannelTitle", param);
    },
    createPannelData: function () {
      (this.pannelData.publicOptions = [
        {
          value: "true",
          text: "True",
        },
        {
          value: "false",
          text: "False",
        },
      ]),
        (this.pannelData.workTypeOptions = [
          {
            value: "remote",
            text: "remote",
          },
          {
            value: "onsite",
            text: "onsite",
          },
          {
            value: "timesheet",
            text: "timesheet",
          },
          {
            value: "full-time",
            text: "full-time",
          },
        ]);
      httpGet("get_add_gig_data").then((response) => {
        if (response.ok) {
          this.pannelData.metroOptions = response.data.metro_options;
          this.isPannelInit = true;
        }
      });
    },
    saveProject: function (projectData) {
      this.submitLoading = true;
      if (projectData.type == constant.PANEL_TYPES.ADD) {
        const saveData = {
          created: moment().valueOf() / 1000,
          title: projectData.title ? projectData.title : null,
          task: projectData.task ? projectData.task : null,
          company: projectData.company ? projectData.company : null,
          phase: projectData.phase ? projectData.phase : null,
          email_notification: projectData.emailNotification
            ? projectData.emailNotification
            : false,
          is_anon: projectData.anonymous ? projectData.anonymous : false,
        };
        addDoc("gigs", saveData)
          .then((result) => {
            if (result.ok) {
              this.$toasted.global.toast_success({
                message: "add success",
              });
              this.closeEditPannel();
            } else {
              this.$toasted.global.toast_error({ message: "add error" });
            }
          })
          .catch((error) => {
            this.$toasted.global.toast_error({ message: error });
          })
          .finally(() => {
            this.submitLoading = false;
          });
      } else if (projectData.type == constant.PANEL_TYPES.EDIT) {
        updateDocById("gigs", projectData.id, {
          title: projectData.title ? projectData.title : null,
          task: projectData.task ? projectData.task : null,
          company: projectData.company ? projectData.company : null,
          phase: projectData.phase ? projectData.phase : null,
          email_notification: projectData.emailNotification
            ? projectData.emailNotification
            : false,
          is_anon: projectData.anonymous ? projectData.anonymous : false,
        })
          .then((result) => {
            if (result.ok) {
              this.$toasted.global.toast_success({
                message: "edit success",
              });
              this.closeEditPannel();
            } else {
              this.$toasted.global.toast_error({ message: "edit error" });
            }
          })
          .catch((error) => {
            this.$toasted.global.toast_error({ message: error });
          })
          .finally(() => {
            this.submitLoading = false;
          });
      }
    },
    deleteProject: function (data) {
      utils.deleteConfirm(async () => {
        const id = data.index;
        const result = await deleteDoc("gigs", id);
        if (result.ok) {
          this.$toasted.global.toast_success({ message: "delete success" });
        } else {
          this.$toasted.global.toast_error({ message: "delete error" });
        }
      });
    },
    updateRowData: function () {
      this.rowData = [];
      this.projects.forEach((item, index) => {
        let submitted = 0;
        let sourced = 0;
        let amount = 0;
        if (
          item.roles &&
          item.roles.length > 0 &&
          item.selected_consultants &&
          item.selected_consultants.length > 0
        ) {
          item.roles.forEach((role) => {
            amount =
              amount +
              (role.rate_to_client ? Number(role.rate_to_client) : 0) *
                4 *
                (role.hours_per_week ? Number(role.hours_per_week) : 0);
            const selectedConsultants = item.selected_consultants;
            const foundRole = selectedConsultants.find(
              (consultant) => consultant.role_id === role.id
            );
            if (foundRole && foundRole.consultants) {
              foundRole.consultants.forEach((c) => {
                sourced++;
                if (c.confirm && c.reply === "yes") {
                  submitted++;
                }
              });
            }
          });
        }
        this.rowData.push({
          ...item,
          createdTime: dateformat(item.created, "MM/DD/YYYY"),
          createdTimeStamp: item.created,
          index: item.id,
          // workType: item.work_type,
          // hoursPerWeek: item.hours_per_week,
          // engagementLength: item.engagement,
          // estimatedStart: dateformat(item.estimated_start, "MM/DD/YYYY"),
          ddOpen: false,
          phase: item.phase,
          company: item.company,
          companyName: this.companies.find((c) => c.id === item.company)?.name,
          sourced,
          submitted,
          amount: isNaN(amount) ? "$0" : "$" + amount,
        });
        this.rowData.sort((a, b) => {
          return b.created - a.created;
        });
        this.rowData.forEach((item, index) => {
          item.rowindex = index;
        });
      });
    },
  },
};
</script>
